import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", "Arial", sans-serif', // Updated to Poppins
  },
});

export default theme;
